// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiplayerToggle-module__multiplayerToggleContainer--ONaCB {
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
  align-items: center;
  justify-content: left;
  padding: 0.75rem;
  height: var(--class-title-height);
  container-type: size;
  border-right: 1px solid var(--Neutral-Variant-200, #cbd5e1);
  border-bottom: 1px solid var(--Neutral-Variant-200, #cbd5e1);
  border-left: 1px solid var(--Neutral-Variant-200, #cbd5e1);
  background: var(--Neutral-Variant-00, #f8fafc);
}

.MultiplayerToggle-module__multiplayerToggle--I9OXa {
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--Neutral-300, #d4d4d8);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  height: 1.875rem;
}
@container (max-width: 21.25rem) {
  .MultiplayerToggle-module__multiplayerToggle--I9OXa {
    width: 2.5rem;
  }
  .MultiplayerToggle-module__multiplayerToggle--I9OXa span {
    display: none;
  }
}

button.MultiplayerToggle-module__multiplayerToggleOn--IQNI9 {
  border: 1px solid var(--Primary-600, #2463eb);
  background: var(--Primary-600, #2463eb);
  color: var(--Neutral-00, #fff);
}

button.MultiplayerToggle-module__multiplayerToggleOff--fic14 {
  border: 1px solid var(--Neutral-300, #d4d4d8);
  color: var(--Neutral-600, #52525b);
}

button.MultiplayerToggle-module__multiplayerToggleLeft--z1eDN {
  border-radius: 0.5rem 0px 0px 0.5rem;
}

button.MultiplayerToggle-module__multiplayerToggleRight--qUX9I {
  border-radius: 0px 0.5rem 0.5rem 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/Theater/MultiplayerToggle.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iCAAA;EACA,oBAAA;EAEA,2DAAA;EACA,4DAAA;EACA,0DAAA;EACA,8CAAA;AAAD;;AAEA;EACC,uBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AACD;AAEC;EAXD;IAYE,aAAA;EACA;EAAA;IACC,aAAA;EAED;AACF;;AAEA;EACC,6CAAA;EACA,uCAAA;EACA,8BAAA;AACD;;AAEA;EACC,6CAAA;EACA,kCAAA;AACD;;AAEA;EACC,oCAAA;AACD;;AAEA;EACC,oCAAA;AACD","sourcesContent":[".multiplayerToggleContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex: 0 0 auto;\n\talign-items: center;\n\tjustify-content: left;\n\tpadding: 0.75rem;\n\theight: var(--class-title-height);\n\tcontainer-type: size;\n\n\tborder-right: 1px solid var(--Neutral-Variant-200, #cbd5e1);\n\tborder-bottom: 1px solid var(--Neutral-Variant-200, #cbd5e1);\n\tborder-left: 1px solid var(--Neutral-Variant-200, #cbd5e1);\n\tbackground: var(--Neutral-Variant-00, #f8fafc);\n}\n.multiplayerToggle {\n\tpadding: 0.5rem 0.75rem;\n\tborder: 1px solid var(--Neutral-300, #d4d4d8);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 0.5rem;\n\tfont-size: 0.875rem;\n\theight: 1.875rem;\n\n\t// If this changes, also change theaterControlButton in ../TheaterCanvasButtons/TheaterCanvasButtons.module.scss\n\t@container (max-width: 21.25rem) {\n\t\twidth: 2.5rem;\n\t\tspan {\n\t\t\tdisplay: none; // Hide button text on smaller screens\n\t\t}\n\t}\n}\n\nbutton.multiplayerToggleOn {\n\tborder: 1px solid var(--Primary-600, #2463eb);\n\tbackground: var(--Primary-600, #2463eb);\n\tcolor: var(--Neutral-00, #fff);\n}\n\nbutton.multiplayerToggleOff {\n\tborder: 1px solid var(--Neutral-300, #d4d4d8);\n\tcolor: var(--Neutral-600, #52525b);\n}\n\nbutton.multiplayerToggleLeft {\n\tborder-radius: 0.5rem 0px 0px 0.5rem;\n}\n\nbutton.multiplayerToggleRight {\n\tborder-radius: 0px 0.5rem 0.5rem 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiplayerToggleContainer": `MultiplayerToggle-module__multiplayerToggleContainer--ONaCB`,
	"multiplayerToggle": `MultiplayerToggle-module__multiplayerToggle--I9OXa`,
	"multiplayerToggleOn": `MultiplayerToggle-module__multiplayerToggleOn--IQNI9`,
	"multiplayerToggleOff": `MultiplayerToggle-module__multiplayerToggleOff--fic14`,
	"multiplayerToggleLeft": `MultiplayerToggle-module__multiplayerToggleLeft--z1eDN`,
	"multiplayerToggleRight": `MultiplayerToggle-module__multiplayerToggleRight--qUX9I`
};
export default ___CSS_LOADER_EXPORT___;
